/**
 * Przełączniki należące do **urządzenia**, nie do konta.
 *
 * Ta sama zasada, którą nosi styl napisów (`player/use-subtitles.ts`): telewizor
 * w salonie i laptop na biurku to nie ta sama osoba z dwoma ustawieniami, tylko dwa
 * urządzenia z własnymi. Tryb TV i klawiatura ekranowa są potrzebne dokładnie tam,
 * gdzie nie ma myszy — więc trzymanie ich na koncie włączałoby je na laptopie.
 *
 * Zapis **nigdy nie rzuca**: `localStorage` jest niedostępny przy zablokowanych
 * ciasteczkach i w części trybów prywatnych, a przełącznik wyglądu nie ma prawa
 * wywrócić ekranu.
 */

const PREFIX = 'anisync.device.';

export function readFlag(key: string, fallback: boolean): boolean {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    if (raw === null) return fallback;
    return raw === '1';
  } catch {
    return fallback;
  }
}

export function writeFlag(key: string, value: boolean): void {
  try {
    window.localStorage.setItem(PREFIX + key, value ? '1' : '0');
  } catch {
    // Brak pamięci trwałej znaczy tylko tyle, że przełącznik nie przeżyje
    // odświeżenia — to mniej szkodliwe niż wyjątek w renderze.
  }
}
